__turbopack_context__.v({
  "error": "style-module-scss-module__YYBg_q__error",
  "field": "style-module-scss-module__YYBg_q__field",
  "fields": "style-module-scss-module__YYBg_q__fields",
  "footer": "style-module-scss-module__YYBg_q__footer",
  "form": "style-module-scss-module__YYBg_q__form",
  "privacy": "style-module-scss-module__YYBg_q__privacy",
  "submit": "style-module-scss-module__YYBg_q__submit",
  "submitLabel": "style-module-scss-module__YYBg_q__submitLabel",
  "submitWrapper": "style-module-scss-module__YYBg_q__submitWrapper",
});
